import {Component} from '@angular/core';
import {PermissionService} from "../../_auth/permission.service";
import {AppRoutes} from "../../enums/routes";
import {NavbarItemLargeComponent} from "../navbar-base/navbar-item-large/navbar-item-large.component";
import {NavbarContainerComponent} from "../navbar-base/navbar-container/navbar-container.component";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-navbar-admin',
  templateUrl: './navbar-admin.component.html',
  imports: [
    CommonModule,
    NavbarItemLargeComponent,
    NavbarContainerComponent
  ],
  styleUrls: ['./navbar-admin.component.scss']
})
export class NavbarAdminComponent {
  protected readonly Routes = AppRoutes;

  constructor(public PermissionService: PermissionService) {
  }
}
